import { Link } from "wouter";
import { Send, ArrowRight, BarChart3, ShieldCheck, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <header className="border-b bg-card">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2 font-bold text-xl text-primary">
            <Send className="h-6 w-6" />
            TDM Registration App
          </div>
          <div className="flex items-center gap-4">
            <Link href="/sign-in">
              <Button variant="ghost">Sign In</Button>
            </Link>
            <Link href="/sign-up">
              <Button>Get Started</Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center p-4 relative overflow-hidden">
        {/* Background grid */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
        
        <div className="max-w-4xl w-full mx-auto text-center space-y-8 z-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            <span className="flex h-2 w-2 rounded-full bg-primary animate-pulse"></span>
            Operational Intelligence
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-foreground">
            Deal registration, <br />
            <span className="text-primary">engineered for speed.</span>
          </h1>
          
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            The precision cockpit for channel sales. Register Salesforce opportunities across multiple suppliers from your own mailbox in seconds, not hours.
          </p>
          
          <div className="flex items-center justify-center gap-4 pt-4">
            <Link href="/sign-up">
              <Button size="lg" className="h-12 px-8 text-base">
                Start Registering <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-16 mt-12 border-t">
            <div className="flex flex-col items-center text-center p-6 bg-card rounded-2xl border shadow-sm">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <BarChart3 className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Salesforce Sync</h3>
              <p className="text-sm text-muted-foreground">Pull opportunity data instantly. No more copy-pasting between tabs.</p>
            </div>
            
            <div className="flex flex-col items-center text-center p-6 bg-card rounded-2xl border shadow-sm">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <Mail className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Connected Mailbox</h3>
              <p className="text-sm text-muted-foreground">Registrations send from your real email. Replies go straight to your inbox.</p>
            </div>
            
            <div className="flex flex-col items-center text-center p-6 bg-card rounded-2xl border shadow-sm">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <ShieldCheck className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Duplicate Guard</h3>
              <p className="text-sm text-muted-foreground">Automatic protection against sending duplicate registrations to the same supplier.</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
